import { Button, Tooltip } from '@ds';
import { MdOutlineInfo } from 'react-icons/md';
import { AssignActionType } from '@/api/apis/resources';
import { getDisabledState, getVariantByActionType, nonLogisticsDetachWarning } from './utils';

type ReserveButtonProps = {
  onReserve: () => void;
  isSelected?: boolean;
  isLogistics: boolean;
  assignActionType: AssignActionType;
};

export const ReserveButton = ({ onReserve, isSelected, isLogistics, assignActionType }: ReserveButtonProps) => {
  const { detachDisabled, attachDisabled } = getDisabledState(assignActionType);
  const variant = getVariantByActionType(assignActionType, isSelected, isLogistics);
  const btnClasses = isSelected ? 'text-danger-30 border-danger-30' : '';
  const showWarning = !isLogistics && detachDisabled;
  const btnDisabled = (attachDisabled && !isSelected) || detachDisabled;

  return (
    <Tooltip content={nonLogisticsDetachWarning} showArrow isDisabled={!showWarning}>
      <div className="flex justify-end w-full">
        <Button
          variant={variant}
          className={`text-s-sb py-2 w-24 h-auto ${btnClasses}`}
          onPress={onReserve}
          isDisabled={btnDisabled}
          startContent={
            showWarning && (
              <div>
                <MdOutlineInfo />
              </div>
            )
          }
        >
          {isSelected ? 'Detach' : 'Reserve'}
        </Button>
      </div>
    </Tooltip>
  );
};
